module.exports = __webpack_public_path__ + "img/AHM Logo New.68ba9b17.png";